import {cpfOrCnpj, ID, InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import StatusCarga from '@/model/resource/StatusCarga'
import DeliverySlaResponse from '@/model/response/DeliverySlaResponse'
import RenderNumber from '@/components/render/RenderNumber.vue'

export default (model: DeliverySlaResponse): Schema => ({

  nome: {
    content: model.nome,
  },

  documento: {
    content: cpfOrCnpj(model.documento),
  },

  dentroSLA: {
    content: {
      component: RenderNumber,
      props: {
        number: model.dentroSLA,
      },
    },
    textContent: model.dentroSLA || '0',
  },

  foraSLA: {
    content: {
      component: RenderNumber,
      props: {
        number: model.foraSLA,
      },
    },
    textContent: model.foraSLA || '0',
  },

  naoInformadoSLA: {
    content: {
      component: RenderNumber,
      props: {
        number: model.naoInformadoSLA,
      },
    },
    textContent: model.naoInformadoSLA || '0',
  },

  porcentagemDentroSLA: {
    content: {
      component: RenderNumber,
      props: {
        number: model.porcentagemDentroSLA,
      },
    },
    textContent: model.porcentagemDentroSLA || '0',
  },

  porcentagemForaSLA: {
    content: {
      component: RenderNumber,
      props: {
        number: model.porcentagemForaSLA,
      },
    },
    textContent: model.porcentagemForaSLA || '0',
  },

  porcentagemNaoInformadoSLA: {
    content: {
      component: RenderNumber,
      props: {
        number: model.porcentagemNaoInformadoSLA,
      },
    },
    textContent: model.porcentagemNaoInformadoSLA || '0',
  },

})
